/**
 * Require
 */
require('./bootstrap');
// require('jquery-validation');
// require('jquery-mask-plugin');
require("../../../node_modules/select2/dist/js/select2.min");
require("../../../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.min");

// setting for url localization, not move

const currentLang = document.documentElement.lang;

const jsonTranslations = JSON.parse($('.js-translate').data('translate'));

window.currentLang = currentLang;

//window.getTranslationText("This model added to favorites");

window.getTranslationText = function (key) {
    try {
        if (currentLang === 'ar-sa') {
            return jsonTranslations[key];
        }
    } catch (e) {
        return key;
    }
    return key;
}

axios.defaults.baseURL = window.location.origin;

axios.interceptors.request.use(config => {
    if (config.method === 'get') {
        config.url = `/${currentLang}${config.url}`;
    }

    return config;
}, error => {
    return Promise.reject(error);
});
// end setting for url localization

import {Centrifuge} from 'centrifuge';

const Swal = require('sweetalert2');

/**
 * Notification for front pages
 * Allow type: success | info | warning | error
 * @param text
 * @param type
 */

window.notify = function (text, type = 'success') {
    Swal.close();
    Swal.fire({
        position: 'top-end',
        icon: type,
        title: text,
        showConfirmButton: false,
        showCloseButton: true,
        timer: 3500,
        timerProgressBar: true,
        toast: true,
    })
}


window.notifyDontClosing = function (text, type = 'success') {
    Swal.close();
    Swal.fire({
        position: 'top-end',
        icon: type,
        title: text,
        showConfirmButton: false,
        showCloseButton: true,
        timer: 6500,
        // timerProgressBar: true,
        toast: true,
    })
}
// const Centrifuge = require("centrifuge");
let centrifugoMeta = $('meta[name="centrifugo"]');
let websocket = centrifugoMeta.attr("data-websocket") && centrifugoMeta.attr("data-websocket").toString();
if (websocket) {
    let token = centrifugoMeta.attr("data-token") && centrifugoMeta.attr("data-token").toString();
    let channel = centrifugoMeta.attr("data-channel") && centrifugoMeta.attr("data-channel").toString();
    const transports = [
        {
            transport: 'websocket',
            endpoint: websocket
        },
    ];
    let centrifuge = new Centrifuge(transports, {token: token});
    // const sub = centrifuge.newSubscription(channel);
    window.sub = centrifuge.newSubscription(channel);
    window.sub.subscribe();
    centrifuge.connect();
    window.sub.history({limit: 100}).then(function (ctx) {
    }, function (err) {
        // history call failed with error
    });
    // TODO after approve logic notification need refactor
    window.sub.on('publication', function (ctx) {
        if (!!localStorage.getItem('lang') === false)  {
            localStorage.setItem('lang','en')
        }
//      implement type of notise by key of arr
        if (ctx.data.successJob) {
            let infoText;
            if ( localStorage.getItem('lang') === 'en') {
                infoText = 'The model is calculated! Please check the results on the "Print your 3D model" page.'
            } else {
                infoText ='"تم الانتهاء من تسعير النماذج بنجاح! الرجاء زيارة صفحة "طلب طباعة ثلاثية الأبعاد'
            }

            Swal.close();
            Swal.fire({
                position: 'top-end',
                heightAuto: false,
                icon: 'success',
                title: infoText,
                showConfirmButton: false,
                showCloseButton: true,
                timer: 6500,
                // timerProgressBar: true,
                toast: true,
            })
        } else if (ctx.data.info) {
            Swal.close();
            Swal.fire({
                position: 'top-end',
                heightAuto: false,
                icon: 'info',
                title: ctx.data.info,
                showConfirmButton: false,
                showCloseButton: false,
                // timer: 3500,
                // timerProgressBar: true,
                toast: true,
            })
        } else if (ctx.data.infoJobStart) {
            let infoText;
            if (localStorage.getItem('lang') === 'en') {
                infoText = `It will take 2-3 minutes to calculate your model! Please check your email for the results.`
            } else {
                infoText = `قد يستغرق تسعير النماذج 2-3 دقائق. سوف يتم إرسال نتائج التسعير إلى بريدك الإلكتروني حين جاهزيتها`
            }
            Swal.close();
            Swal.fire({
                position: 'top-end',
                heightAuto: false,
                icon: 'info',
                title: infoText,
                showConfirmButton: false,
                showCloseButton: false,
                // timer: 3500,
                // timerProgressBar: true,
                toast: true,
            })
        } else if (ctx.data.infoJobFinish) {
            let infoText;
            if (localStorage.getItem('lang') === 'en') {
                infoText = `The model will be calculated in ${ctx.data.infoJobFinish} minutes. Please check your email for the results.`
            } else {
                infoText = 'دقائق. سوف يتم إرسال نتائج التسعير إلى بريدك الإلكتروني حين جاهزيتها' + ctx.data.infoJobFinish + 'قد يستغرق تسعير النماذج أكثر من'
            }

            Swal.close();
            Swal.fire({
                position: 'top-end',
                heightAuto: false,
                icon: 'info',
                title: infoText,
                showConfirmButton: false,
                showCloseButton: false,
                // timer: 3500,
                // timerProgressBar: true,
                toast: true,
            })
        } else if (ctx.data.warning) {
            Swal.close();
            Swal.fire({
                position: 'top-end',
                heightAuto: false,
                icon: 'warning',
                title: ctx.data.warning,
                showConfirmButton: false,
                showCloseButton: true,
                timer: 6500,
                timerProgressBar: true,
                toast: true,
            })
        } else if (ctx.data.error) {
            Swal.close();
            Swal.fire({
                position: 'top-end',
                heightAuto: false,
                icon: 'warning',
                title: ctx.data.error,
                showConfirmButton: true,
                showCloseButton: true,
                // timer: 5500,
                // timerProgressBar: true,
                toast: true,
            })
        }
    });
    window.autoNotifyResultsInHeader = function () {
        let data = [];

        axios.get('/cura_results').then(function (response) {
            data = response.data;
            if (data.length > 0) {
                $('.js-notify-cura-results').show();
            } else {
                $('.js-notify-cura-results').hide();
            }
        })

    }

    window.autoNotifyResultsInHeader();
}

